// extracted by mini-css-extract-plugin
export default {"title":"SixthScreen_title__10LRi"};